import React, { FC } from "react";

import {
  useApisMembersKnowledgeInsightPostCommentsLikedEmployeesIndex,
  useArray,
} from "~/hooks";

import { ReactedEmployeesModal } from "~/components/molecules";

import { ReactedEmployeeType } from "~/domains";

type PropsType = {
  knowledgeInsightPostCommentId: string;
  onClose: () => void;
};

export const KnowledgeInsightPostCommentsLikedEmployeesModal: FC<PropsType> = ({
  knowledgeInsightPostCommentId,
  onClose,
}: PropsType) => {
  const { items, setItems } = useArray<ReactedEmployeeType>([]);
  const { fetchNextPage, hasNextPage, isLoading } =
    useApisMembersKnowledgeInsightPostCommentsLikedEmployeesIndex({
      knowledgeInsightPostCommentId,
      config: {
        onSuccess: (data) => {
          setItems(
            data.pages
              .map((page) => page.knowledgeInsightPostCommentLikes)
              .flat(),
          );
        },
      },
    });
  return (
    <ReactedEmployeesModal
      headerTitle="いいねしたユーザー"
      onClose={onClose}
      reactedEmployees={items}
      nextFetchFunction={fetchNextPage}
      hasMore={hasNextPage}
      isLoading={isLoading}
    />
  );
};
